import { createSelector } from '@ngrx/store';
import { productSettingsAdapter } from '../reducer/products.reducer';
import { selectProductsState } from './products.selectors';

// Get the entity selectors from the adapter
const { selectAll: selectAllProductsSettingsFromAdapter } = productSettingsAdapter.getSelectors();

// Select the productSettings EntityState
export const selectProductsSettingsState = createSelector(selectProductsState, (state) => state.productsSettings);

// Select all product settings as an array
export const selectProductsSettings = createSelector(selectProductsSettingsState, selectAllProductsSettingsFromAdapter);
